import './scss/style.scss';

import './components/quit.js';

import "./components/top_menu/component.js";
import "./components/bottom_menu/component.js";
import "./components/maps/component.js";
import "./components/circles/component.js";
import "./components/pins/component.js";
import "./components/analytics/component.js";

import responsive from './components/responsive/component.js';
import inactivity from './components/inactivity.js';
import quit from './components/quit.js';

responsive.init();